module.exports = __webpack_public_path__ + "img/UK-North.7d27bab9.png";